import React from "react";
import { useAdminAuth, AdminAuthProvider } from "@/admin/AdminAuthContext";
import { AdminLogin } from "@/admin/AdminLogin";
import { AdminDashboard } from "@/admin/AdminDashboard";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";

const Gate = () => {
  const { admin, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8F5F0] flex items-center justify-center text-[#5C625E]">
        <Loader2 className="h-5 w-5 animate-spin" />
      </div>
    );
  }
  return admin ? <AdminDashboard /> : <AdminLogin />;
};

export const AdminApp = () => (
  <AdminAuthProvider>
    <Gate />
    <Toaster
      position="top-center"
      richColors
      toastOptions={{
        classNames: {
          toast:
            "!rounded-none !border !border-[#2C302E]/15 !bg-[#F8F5F0] !text-[#2C302E] !font-light",
          title: "!font-serif !text-base",
          description: "!text-sm !text-[#5C625E]",
        },
      }}
    />
  </AdminAuthProvider>
);
